import { render, staticRenderFns } from "./TicketSelectPriority.vue?vue&type=template&id=def6ea62&"
import script from "./TicketSelectPriority.vue?vue&type=script&lang=ts&"
export * from "./TicketSelectPriority.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('def6ea62')) {
      api.createRecord('def6ea62', component.options)
    } else {
      api.reload('def6ea62', component.options)
    }
    module.hot.accept("./TicketSelectPriority.vue?vue&type=template&id=def6ea62&", function () {
      api.rerender('def6ea62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketSelectPriority.vue"
export default component.exports